const customStyles = () => {
  return {
    option: (base, state) => ({
      ...base,
      padding: 5
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      padding: 3
    }),
    control: (base, state) => ({
      ...base,
      minHeight: 3
      // width: width || 300
    })
  };
};

export { customStyles };
